import {Component, OnInit} from '@angular/core';
import {AutenticacionService} from '../../_services/autenticacion.service';
import {Funcionalidad} from '../../_models/funcionalidad';
import {PermisosSeccionesControlesService} from '../../_services/permisos-secciones-controles.service';

export enum TabAdmgar {
  LISTADO = 'LISTADO',
  GARANTIA_IDONEA = 'GARANTIA_IDONEA',
  SUBSIDIO = 'SUBSIDIO'
}

/** Códigos de sección configurados para cada tabs */
const SECCION_CODIGO: Record<TabAdmgar, string> = {
  [TabAdmgar.LISTADO]: 'ADMLGI',
  [TabAdmgar.GARANTIA_IDONEA]: 'ADMGRI',
  [TabAdmgar.SUBSIDIO]: 'ADMSUB',
};

@Component({
  selector: 'app-admgar',
  templateUrl: 'admgar.component.html',
  styleUrls: ['admgar.component.scss']
})
export class AdmgarComponent implements OnInit {

  /** Referencia al enum para uso en el template */
  tabEnum = TabAdmgar;

  /** Pestaña actualmente seleccionada */
  tabActiva = TabAdmgar.LISTADO;

  /** Registro de pestañas que han sido visitadas al menos una vez (lazy render) */
  tabsVisitadas = new Set<TabAdmgar>([TabAdmgar.LISTADO]);

  /** Definición de las pestañas con su etiqueta, estado de habilitación y visibilidad */
  tabs: { key: TabAdmgar; label: string; disabled: boolean; hidden: boolean }[] = [
    {key: TabAdmgar.LISTADO, label: 'Listado de garantías', disabled: false, hidden: false},
    {key: TabAdmgar.GARANTIA_IDONEA, label: 'Garantía idónea', disabled: false, hidden: false},
    {key: TabAdmgar.SUBSIDIO, label: 'Subsidio', disabled: true, hidden: false},
  ];

  /** Permisos del usuario autenticado para la funcionalidad */
  menu: Funcionalidad = new Funcionalidad();

  /**
   * Sección ADMLGI ya procesada
   */
  seccionListado: any = null;
  seccionGarantiaIdonea: any = null;

  cargando = true;

  constructor(
    private autServicio: AutenticacionService,
    private permisosService: PermisosSeccionesControlesService,
  ) {
  }

  ngOnInit(): void {
    const fn = this.autServicio.obtenerFuncionalidades().find(x => x.ruta === 'apl/administrador-garantias-idoneas');
    if (fn) {
      this.menu = fn;
      this.cargarPermisosSecciones(fn.codigo);
    }
  }

  /**
   * Consulta los permisos aplica a las pestañas
   */
  private cargarPermisosSecciones(codigoFuncionalidad: string): void {
    this.permisosService.getPermisosFuncionalidad(codigoFuncionalidad).subscribe({
      next: (secciones) => {
        this.seccionListado = secciones['ADMLGI'] ?? null;
        this.seccionGarantiaIdonea = secciones['ADMGRI'] ?? null;
        this.cargando = false;
        this.tabs = this.tabs.map(tab => {
          if (tab.key === TabAdmgar.SUBSIDIO) {
            return {...tab, disabled: true};
          }
          const seccion = secciones[SECCION_CODIGO[tab.key]];
          if (!seccion) {
            return tab;
          }
          seccion.editable = seccion.visible && seccion.habilitado;
          seccion.controles?.forEach(c => c.editable = seccion.visible && (c.editable || c.habilitado));
          return {...tab, hidden: !seccion.visible, disabled: !seccion.editable};
        });

        const tabActual = this.tabs.find(t => t.key === this.tabActiva);
        if (tabActual && (tabActual.hidden || tabActual.disabled)) {
          const primera = this.tabs.find(t => !t.hidden && !t.disabled);
          if (primera) {
            this.seleccionar(primera.key);
          }
        }
      },
      error: () => {}
    });
  }

  /**
   * Activa la pestaña indicada y la registra como visitada para preservar su estado.
   */
  seleccionar(key: TabAdmgar): void {
    this.tabsVisitadas.add(key);
    this.tabActiva = key;
  }
}
